export default __webpack_public_path__ + "static/media/College.224eab43.PNG";